/**
 * slugify — strip diacritics, lowercase, hyphenate, remove non-alphanumeric.
 *
 * Used wherever a city or neighborhood name from a Google Places result must be
 * turned into a URL slug that matches the canonical City.slug stored in the DB.
 *
 * Examples:
 *   'Ciudad de México'  → 'ciudad-de-mexico'
 *   'Gràcia'            → 'gracia'
 *   'Île-de-France'     → 'ile-de-france'
 */
export function slugify(s: string): string {
  return s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip combining diacritical marks
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}
